import axios from 'axios';
import store from './store';

export const getData = async (address) => {
    const request = await axios({
        url: `${process.env.VUE_APP_API_URL}/api/admin/${address}`,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
            Accept: 'application/json',
        },
        method: 'GET',
    }).catch((error) => error.response);
    if (request.status === 401) {
        store.dispatch('logout');
    }
    return request;
};

export const deleteItem = async (address, raw) => {
    const request = await axios({
        url:
            raw === true
                ? address
                : `${process.env.VUE_APP_API_URL}/api/admin/${address}`,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
            Accept: 'application/json',
        },
        method: 'DELETE',
    }).catch((error) => error.response);
    if (request.status === 401) {
        store.dispatch('logout');
    }
    return request;
};

export const addData = async (address, content) => {
    const request = await axios({
        url: `${process.env.VUE_APP_API_URL}/api/admin/${address}`,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
            Accept: 'application/json',
        },
        method: 'POST',
        data: content,
    }).catch((error) => error.response);
    if (request.status === 401) {
        store.dispatch('logout');
    }
    return request;
};

export const uploadData = async (address, content) => {
    const request = await axios({
        url: `${process.env.VUE_APP_API_URL}/api/admin/${address}`,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
            'content-type': 'multipart/form-data',
        },
        method: 'POST',
        data: content,
    }).catch((error) => error.response);

    if (request.status === 401) {
        store.dispatch('logout');
    }

    return request;
};

export const updateData = async (address, content) => {
    const request = await axios({
        url: `${process.env.VUE_APP_API_URL}/api/admin/${address}`,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
            Accept: 'application/json',
        },
        method: 'PUT',
        data: content,
    }).catch((error) => error.response);
    if (request.status === 401) {
        store.dispatch('logout');
    }
    return request;
};

export const download = async (address) => {
  const response = await axios({
    url: process.env.VUE_APP_API_URL + '/api/admin/' + address,
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      'Accept': 'application/json',
    },
    responseType: 'arraybuffer',
    method: 'GET'
  });

  let blob = new Blob([response.data], {type: response.data.type});
  let url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let fileName = 'unknown';
  if (contentDisposition) {
    const regex = /filename="?(.*)"?/gmi;
    const fileNameMatch = regex.exec(contentDisposition);
    if (fileNameMatch.length === 2)
      fileName = fileNameMatch[1];
  }
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return response;
};
